<template>
  <div>
    <div class="modal">
      <div class="modal__bg" @click="$emit('close', modalParams)"></div>
      <div
        :class="`modal__body ${modalParams.name}`"
        :style="{
          width: modalParams.width ? `${modalParams.width}px` : '650px'
        }"
        ref="modalBody"
      >
        <div v-if="modalParams.name === 'custom-range'">
          <h4 class="modal__header">
            <span>Select Date Range</span>
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <SelectDate @close="$emit('close')" />
        </div>
        <div
          v-if="
            modalParams.name === 'add-member' ||
              modalParams.name === 'edit-member' ||
              modalParams.name === 'change-password'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-member'">Add New Member</span>
            <span v-if="modalParams.name === 'edit-member'"
              >Edit Member Details</span
            >
            <span v-if="modalParams.name === 'change-password'"
              >Change Password</span
            >
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddNewMember
            :singleRecord="modalParams.singleRecord"
            @close="$emit('close')"
            v-if="modalParams.name != 'change-password'"
          />
          <ChangePassword
            :singleRecord="modalParams.singleRecord"
            @close="$emit('close')"
            v-if="modalParams.name == 'change-password'"
          />
        </div>
        <div
          v-if="
            modalParams.name === 'add-group' ||
              modalParams.name === 'edit-group'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-group'">Add New Group</span>
            <span v-if="modalParams.name === 'edit-group'">Edit Group</span>
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddNewGroup
            :singleRecord="modalParams.singleRecord"
            @close="$emit('close')"
            @toggleScroll="handleToggleScroll"
          />
        </div>
        <div
          v-if="
            modalParams.name === 'add-event' ||
              modalParams.name === 'edit-event'
          "
        >
          <h4 class="modal__header mb-30">
            <span v-if="modalParams.name === 'add-event'">Add New Event</span>
            <span v-if="modalParams.name === 'edit-event'">Edit Event</span>
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddNewEvent
            @close="$emit('close')"
            :singleRecord="modalParams.singleRecord"
            @toggleScroll="handleToggleScroll"
          />
        </div>
        <div v-if="modalParams.name === 'report-bug'">
          <h4 class="modal__header">
            Report an Issue
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <ReportABug @close="$emit('close')" />
        </div>
        <div v-if="modalParams.name === 'add-group-member'">
          <h4 class="modal__header">
            Add Members
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddCompanyMembers
            :singleRecord="modalParams.singleRecord"
            @close="$emit('close')"
          />
        </div>
        <div v-if="modalParams.name === 'add-event-participant'">
          <h4 class="modal__header">
            Add Participants
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddEventParticipant
            :singleEventId="modalParams.id"
            @close="$emit('close')"
          />
        </div>
        <div v-if="modalParams.name === 'book-a-member'">
          <h4 class="modal__header">
            Book existing member
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <BookAMember />
        </div>
        <div
          v-if="
            modalParams.name === 'add-category' ||
              modalParams.name === 'edit-category'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-category'">Add Category</span>
            <span v-if="modalParams.name === 'edit-category'"
              >Edit Category</span
            >
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddCategory
            @toggleScroll="handleToggleScroll"
            :singleRecord="modalParams.singleRecord"
            :link="modalParams.link"
            @close="$emit('close')"
          />
        </div>
        <div
          v-if="
            modalParams.name === 'add-location' ||
              modalParams.name === 'edit-location'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-location'">Add Location</span>
            <span v-if="modalParams.name === 'edit-location'"
              >Edit Location</span
            >
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddLocation
            :singleRecord="modalParams.singleRecord"
            :link="modalParams.link"
            @close="$emit('close')"
          />
        </div>
        <div
          v-if="
            modalParams.name === 'add-inclusion' ||
              modalParams.name === 'edit-inclusion'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-inclusion'"
              >Add Inclusion</span
            >
            <span v-if="modalParams.name === 'edit-inclusion'"
              >Edit Inclusion</span
            >
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddInclusion
            :singleRecord="modalParams.singleRecord"
            :link="modalParams.link"
            @close="$emit('close')"
          />
        </div>
        <div
          v-if="
            modalParams.name === 'add-term' || modalParams.name === 'edit-term'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-term'">Add Term</span>
            <span v-if="modalParams.name === 'edit-term'">Edit Term</span>
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddTerm
            :singleRecord="modalParams.singleRecord"
            :link="modalParams.link"
            :modalName="modalParams.name"
            @close="$emit('close')"
          />
        </div>
        <div
          v-if="
            modalParams.name === 'add-schedule' ||
              modalParams.name === 'edit-schedule'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-schedule'">Add Schedule</span>
            <span v-if="modalParams.name === 'edit-schedule'"
              >Edit Schedule</span
            >
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddSchedule
            :singleRecord="modalParams.singleRecord"
            :link="modalParams.link"
            @close="$emit('close')"
          />
        </div>
        <div
          v-if="
            modalParams.name === 'add-package' ||
              modalParams.name === 'edit-package'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-package'">Add Product</span>
            <span v-if="modalParams.name === 'edit-package'">Edit Product</span>
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddPackage
            :singleRecord="modalParams.singleRecord"
            :link="modalParams.link"
            @toggleScroll="handleToggleScroll"
            @close="$emit('close')"
          />
        </div>
        <div
          v-if="
            modalParams.name === 'add-inventory' ||
              modalParams.name === 'edit-inventory'
          "
        >
          <h4 class="modal__header">
            <span v-if="modalParams.name === 'add-inventory'"
              >Add Inventory</span
            >
            <span v-if="modalParams.name === 'edit-inventory'"
              >Edit Inventory</span
            >
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddProduct
            @toggleScroll="handleToggleScroll"
            :singleRecord="modalParams.singleRecord"
            :link="modalParams.link"
            @close="$emit('close')"
          />
        </div>
        <div v-if="modalParams.name === 'view-member-profile'">
          <h4 class="modal__header">
            Profile overview
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <ViewMemberProfile
            :modalParams="modalParams"
            @close="$emit('close')"
          />
        </div>
        <div v-if="modalParams.name === 'add-whitelisted-domain'">
          <h4 class="modal__header">
            Add Whitelisted Domain
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddWhitelistedDomain />
        </div>
        <div v-if="modalParams.name === 'add-email'">
          <h4 class="modal__header">
            Add Email
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddEmail @close="$emit('close')" />
        </div>
        <div v-if="modalParams.name === 'add-whitelisted-manager'">
          <h4 class="modal__header">
            Add Whitelisted Staff
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <AddManager />
        </div>
        <div v-if="modalParams.name === 'edit-settings'">
          <h4 class="modal__header mb-0">
            Activate Notifications
            <img
              src="~@/assets/media/icons/close.svg"
              alt="close icon"
              @click="$emit('close')"
            />
          </h4>
          <EditNotification :user="modalParams.user" />
        </div>
        <ProfileEdit
          v-if="modalParams.name === 'edit'"
          @close="$emit('close')"
        />
        <BulkUploadMember
          v-if="modalParams.name === 'bulk-upload-member'"
          @close="$emit('close')"
          @fetching="handleFetching"
        />
        <div v-if="modalParams.name === 'linked-products'">
          <LinkedProducts @close="$emit('close')" />
        </div>
      </div>
    </div>
    <FetchingOverlay v-if="fetching" />
  </div>
</template>

<script>
import FetchingOverlay from "@/components/FetchingOverlay";
import {
  BookAMember,
  AddCategory,
  AddPackage,
  AddLocation,
  AddInclusion,
  AddTerm,
  AddSchedule,
  AddProduct,
  AddWhitelistedDomain,
  AddEmail,
  AddManager,
  AddNewMember,
  AddNewGroup,
  EditNotification,
  AddNewEvent,
  AddEventParticipant,
  SelectDate,
  BulkUploadMember,
  LinkedProducts
} from "@/modules/admin/elements/forms";

// Modal from Concierge
import {
  ChangePassword,
  AddCompanyMembers,
  ViewMemberProfile,
  ReportABug
} from "@/modules/concierge/elements/forms";

import ProfileEdit from "./ProfileEdit";

export default {
  name: "Modal",
  components: {
    AddNewMember,
    AddNewGroup,
    AddNewEvent,
    AddCompanyMembers,
    ChangePassword,
    ReportABug,
    AddEventParticipant,
    BookAMember,
    AddCategory,
    AddLocation,
    AddInclusion,
    AddTerm,
    AddSchedule,
    AddProduct,
    ViewMemberProfile,
    AddWhitelistedDomain,
    AddEmail,
    AddManager,
    AddPackage,
    EditNotification,
    ProfileEdit,
    FetchingOverlay,
    SelectDate,
    BulkUploadMember,
    LinkedProducts
  },
  props: {
    backTo: String,
    isOpened: {
      type: Boolean,
      default: false
    },
    modalParams: {
      type: Object,
      default: () => {}
    }
  },
  destroyed() {
    document.body.style.overflow = "initial";
  },
  beforeDestroy() {
    document.getSelection().removeAllRanges();
    document.body.classList.remove("no-select");
  },
  mounted() {
    document.body.style.overflow = "hidden";
    document.body.classList.add("no-select");
  },
  data() {
    return {
      fetching: false
    };
  },
  created() {},
  methods: {
    handleToggleScroll(params) {
      const { scroll } = params;
      this.$refs.modalBody.style.overflow = scroll ? "auto" : "hidden";
    },
    handleFetching(value) {
      this.fetching = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.h-0 {
  height: 0;
}
.modal {
  display: block;
  min-height: 100vh;
  left: 0;
  width: 100%;

  /deep/ &__bg {
    background-color: black;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  /deep/ &__body {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: auto;
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 650px;
    z-index: 1;
    &.add-group-member,
    &.edit-schedule,
    &.add-schedule {
      overflow: visible;
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  /deep/ &__header {
    color: $gray-900;
    font-size: $font-size-base;
    margin-bottom: 40px;
    position: relative;
    span {
      font-family: "Gotham", sans-serif;
    }
    img {
      cursor: pointer;
      top: 0;
      position: absolute;
      right: 0;
    }
    & + h5 {
      color: $gray-900;
      font-family: "Gotham Book";
      font-size: $font-size-sm;
      margin-bottom: 40px;
      margin-top: 10px;
      span {
        color: $brand-primary;
      }
    }
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>
